import type { TplTemplateVO } from '@/3.0/ai-viral-template/_components/template-ui/types';

import type { HeroVideoItem, TemplateVideoItem } from './config';

/** 与下方 templateGrid 共用列表时，由 TemplateVideoItem 映射 Hero 跑马灯条目 */
export function mapTemplateVideoItemsToHeroVideos(
  items: TemplateVideoItem[],
): HeroVideoItem[] {
  return items.map((t) => ({
    id: t.id,
    label: t.title,
    poster: t.poster,
    videoUrl: t.videoUrl,
  }));
}

/** 与爆款模板列表 `/ugc/*` 路径一致，用于首页展示大类角标 */
const UGC_CATEGORY_LABEL: Record<string, string> = {
  '/ugc/1': 'Hook',
  '/ugc/2': 'Personal care',
  '/ugc/3': 'Health',
  '/ugc/4': 'Trending',
  '/ads': 'Ads',
};

/** 接口无趋势数据，首页卡片右上角趋势数用本地 mock 轮换 */
const MOCK_TEMPLATE_TRENDS = [
  '1.2M',
  '650K',
  '920K',
  '980K',
  '540K',
  '880K',
  '850K',
  '430K',
  '760K',
  '720K',
  '380K',
  '690K',
] as const;

export function mapTplVoToTemplateVideoItem(
  vo: TplTemplateVO,
  listIndex = 0,
): TemplateVideoItem | null {
  const poster = vo.cover?.trim() ?? '';
  const videoUrl = vo.preview?.trim() ?? '';
  if (!poster && !videoUrl) return null;

  const title = vo.name?.trim() || vo.description?.trim() || 'Template';
  const trend = MOCK_TEMPLATE_TRENDS[listIndex % MOCK_TEMPLATE_TRENDS.length];

  return {
    id: String(vo.id),
    category: UGC_CATEGORY_LABEL[vo.category] ?? 'Template',
    trend,
    title,
    poster: poster || videoUrl,
    videoUrl: videoUrl || undefined,
  };
}

export function mapTplListToTemplateVideos(list: TplTemplateVO[]): TemplateVideoItem[] {
  return list
    .map((vo, index) => mapTplVoToTemplateVideoItem(vo, index))
    .filter((x): x is TemplateVideoItem => x !== null);
}

/** Hero「Template」tab：与模板区同源列表，映射为跑马灯条目 */
export function mapTplVoToHeroVideoItem(vo: TplTemplateVO): HeroVideoItem | null {
  const poster = (vo.cover?.trim() || vo.preview?.trim() || '') as string;
  const videoUrl = (vo.preview?.trim() || '') as string;
  if (!poster && !videoUrl) return null;
  return {
    id: String(vo.id),
    label: vo.name?.trim() || 'Template',
    poster: poster || videoUrl,
    videoUrl: videoUrl || undefined,
  };
}

export function mapTplListToHeroVideos(list: TplTemplateVO[]): HeroVideoItem[] {
  return list
    .map((vo) => mapTplVoToHeroVideoItem(vo))
    .filter((x): x is HeroVideoItem => x !== null);
}
